export default "__VITE_ASSET__c764f349__"